import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { LicenseService } from 'common/util/module'
import { MediaFile, MediaFileBundle, MediaRoot, MediaRootPermission } from 'elements-sdk'
import { WorkflowService } from 'media.workflow/services/workflow.service'

@Component({
  selector: 'media-info-popover',
  templateUrl: './mediaInfoPopover.component.pug',
  styleUrls: ['./mediaInfoPopover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaInfoPopoverComponent {
  @Input() directory?: MediaFile
  @Input() bundle?: MediaFileBundle
  @Input() permission?: MediaRootPermission
  @Input() fields: Record<string, any>
  @Input() root?: MediaRoot

  constructor (
    public workflow: WorkflowService,
    public license: LicenseService,
  ) { }
}
